import React from "react";
import ReactDOM from "react-dom/client";
import styled from "styled-components";


export const contactList = [
  {
    id: 1,
    name: "Mariam Wifey",
    profilePic: "/profile/mariamife.jpeg",
    lastText: "Husband, come eat Chicken!",
    lastTextTime: "12:58 PM",
  },
  {
    id: 2,
    name: "Dev tutor",
    profilePic: "/profile/theindiandev.jpeg",
    lastText: `I'm with @daybor`,
    lastTextTime: "12:45 PM",
  },
  {
    id: 3,
    name: "Elon Bezoz",
    profilePic: "profile/elon.jpeg",
    lastText: "Where is my Tesla?",
    lastTextTime: "12:30 PM",
  },
  {
    id: 4,
    name: "Jeff Musk",
    profilePic: "profile/jeff.jpeg",
    lastText: "Travelling to space",
    lastTextTime: "12:00 PM",
  },
];


export const messageList = [
  {
    id: 1,
    messageType: "TEXT",
    text: "Hey Man 😁",
    senderID: 0,
    addedOn: "12:00 PM",
  },
  {
    id: 2,
    messageType: "TEXT",
    text: "Hey, What's up?",
    senderID: 1,
    addedOn: "12:01 PM",
  },
  {
    id: 3,
    messageType: "TEXT",
    text: "All Good, What about you?",
    senderID: 0,
    addedOn: "12:00 PM",
  },
  {
    id: 4,
    messageType: "TEXT",
    text: "I'm good as well",
    senderID: 1,
    addedOn: "12:00 PM",
  },
  {
    id: 5,
    messageType: "TEXT",
    text: "Great 😁",
    senderID: 0,
    addedOn: "12:00 PM",
  },
  {
    id: 5,
    messageType: "TEXT",
    text: "Have you subscribed The Indian Dev ?",
    senderID: 1,
    addedOn: "12:00 PM",
  },
];


export default 'mockData';
